// @flow
import * as React from 'react';

export const ToastContext = React.createContext<{ ref: ?{ current: ?HTMLElement } }>({
  ref: null,
});
